import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  actions: {
    create({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckInTransactions", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    CreateCheckInForReturnCheckOut({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckInTransactions/for-return-checkout", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  }
};
